var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33 12.561a4.237 4.237 0 118.475 0H6.33z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33 12.561a4.237 4.237 0 118.475 0H6.33z",
    stroke: "#666",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14 14.563a.583.583 0 11-1.114.348.583.583 0 011.114-.348M9.63 16.719a.583.583 0 11-1.115.347.583.583 0 011.114-.347M12.563 16.719a.583.583 0 11-1.115.347.583.583 0 111.115-.347M11.125 14.563a.584.584 0 11-1.114.348.584.584 0 011.114-.348M14.11 14.563a.583.583 0 11-1.113.349.583.583 0 011.113-.35",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.567 8.324v-.396a3.849 3.849 0 017.697 0V19.92",
    stroke: "#666",
    strokeLinecap: "round"
  }))));
}
export default SvgShower;